import { BTW_FRACTIE } from './pricing-core.js';
/** Te koop via Stripe-checkout (éénmalig); server valideert IDs. */
export const CHECKOUT_ADDON_IDS = ['tweede_berekening'];
export const CHECKOUT_ADDONS = {
    tweede_berekening: {
        id: 'tweede_berekening',
        titel: 'Tweede berekening',
        beschrijving: 'Later een tweede scan met nieuwe invoer in hetzelfde account — extra rapport/export.',
        eurInclBtwB2C: 19.99,
        eurExBtwB2B: 16.52,
    },
};
export function isCheckoutAddonId(s) {
    return CHECKOUT_ADDON_IDS.includes(s);
}
/** Unieke, bekende add-on IDs (max 1). */
export function sanitizeCheckoutAddonIds(raw) {
    if (!Array.isArray(raw))
        return [];
    const out = [];
    const seen = new Set();
    for (const x of raw) {
        if (typeof x !== 'string' || !isCheckoutAddonId(x) || seen.has(x))
            continue;
        seen.add(x);
        out.push(x);
        if (out.length >= 1)
            break;
    }
    return out;
}
function eurToCents(e) {
    return Math.round(e * 100);
}
/**
 * Stripe Checkout `line_items` met `price_data` (geen vooraf aangemaakte Price IDs nodig).
 * B2B: hoofdproduct en add-ons als ex + aparte btw-regels per onderdeel.
 */
export function buildStripeCheckoutLineItems(snapshot, addonIds) {
    const lines = [];
    const bundleLabel = snapshot.bundleTier === 'basis'
        ? 'Comfort Basis (zonder AI-adviesrapport)'
        : 'Comfort Plus (incl. AI-adviesrapport)';
    if (snapshot.isZakelijk) {
        lines.push({
            name: `ComfortTool — ${bundleLabel}, band ${snapshot.band} (excl. btw)`,
            unit_amount: eurToCents(snapshot.hoofdbedrag),
            quantity: 1,
        });
        lines.push({
            name: 'Btw 21% — hoofdbundel',
            unit_amount: eurToCents(snapshot.btwBedrag),
            quantity: 1,
        });
        for (const id of addonIds) {
            const a = CHECKOUT_ADDONS[id];
            const ex = a.eurExBtwB2B;
            const btw = Math.round(ex * BTW_FRACTIE * 100) / 100;
            lines.push({
                name: `${a.titel} (excl. btw)`,
                unit_amount: eurToCents(ex),
                quantity: 1,
            });
            lines.push({
                name: `Btw 21% — ${a.titel}`,
                unit_amount: eurToCents(btw),
                quantity: 1,
            });
        }
    }
    else {
        lines.push({
            name: `ComfortTool — ${bundleLabel}, band ${snapshot.band} (incl. 21% btw)`,
            unit_amount: eurToCents(snapshot.hoofdbedrag),
            quantity: 1,
        });
        for (const id of addonIds) {
            const a = CHECKOUT_ADDONS[id];
            lines.push({
                name: `${a.titel} (incl. 21% btw)`,
                unit_amount: eurToCents(a.eurInclBtwB2C),
                quantity: 1,
            });
        }
    }
    return lines;
}
/** Som van alle line items in euro (controle). */
export function totalEurFromStripeLines(lines) {
    let c = 0;
    for (const l of lines)
        c += l.unit_amount * l.quantity;
    return c / 100;
}
